import React, {PureComponent, PropTypes} from 'react'
import ButtonControl from 'components/ButtonControl'
import IconControl from 'components/IconControl'
import TipControl from 'components/TipControl'
import AnimationCount from 'components/AnimationCount'
import InstantBookingStore from 'stores/InstantBookingStore'
import { translate as t } from 'lang'
import './TotalPrice.scss'
import {Record} from "immutable";
import classNames from "classnames";

const RIGHT_BUTTON_ARROW = <IconControl name="rightArrow" size="s"/>

function getStateFromStores() {
    return {
        isTotalPrice: InstantBookingStore.getPartDay().size > 0,
        prices: InstantBookingStore.getPrices(),
    };
}

class TotalPrice extends PureComponent {
    
    static propTypes = {
        price: PropTypes.number,
        onSubmit: PropTypes.func,
        submitText: PropTypes.string,
        errors: PropTypes.object,
        parameters: PropTypes.objectOf(Record),
    };

    constructor(props) {
        super(props);

        this.state = {
            ...getStateFromStores(),
            prevPrice: 0,
        };
    }

    componentDidMount() {
        InstantBookingStore.addChangeListener(this._onChange);
    }

    componentDidUpdate(prevProps) {
        if (this.props.price !== prevProps.price) {
            this.setState({
                prevPrice : prevProps.price,
            })
        }
    }

    componentWillUnmount() {
        InstantBookingStore.removeChangeListener(this._onChange);
    }

    _onChange = () => {
        this.setState(getStateFromStores());
    };

    renderErrors = () => {
        let paramsErrors = []
        
        if (this.props.errors.params) {
            Object.keys(this.props.parameters).forEach(objectKey => {
                const param = this.props.parameters[objectKey]
                const paramError = this.props.errors.params[param.id]
                
                if (paramError) {
                    paramsErrors.push(<div key={param.id}>{param.title + ': ' + t(paramError)}</div>)
                }
            })
            
            return paramsErrors.length > 0 ? paramsErrors : null
        }
        
        return null
    }

    render() {
        const {isTotalPrice, prevPrice} = this.state;
        const label = (isTotalPrice ? 'Итоговая' : 'Примерная') + ' стоимость перевозки';
        const tipLabel = isTotalPrice ? 'Эта цена фиксирована и окончательна, мы работаем без почасовых оплат и скрытых комиссий.' : 'Для точного подсчета стоимости выберите время и дополнительные услуги';
        let price = this.props.price;

        if (price === 0) {
            if (this.state.prices.size > 0) {
                const pricesData = this.state.prices.filter(data => {
                    return data.date_desc.best_price === 1;
                });

                if (pricesData.size === 0) {
                    return false;
                }

                let priceData = pricesData.valueSeq().get(0);
                if (!priceData) {
                    return false;
                }

                price = Object.values(priceData.part_day[0])[0].price;
            }
        }

        const TotalPriceLabelClasses = classNames({
            'TotalPrice-label': true,
            'TotalPrice-label--active': isTotalPrice,
        });

        const priceAnimationSettings = {
            start: prevPrice,
            count: price,
            duration: 1000,
            decimals: 0,
            useMoneyFormat: true,
        };

        return (
            <div className="TotalPrice">
                <div className={TotalPriceLabelClasses}>
                    {label}
                    <TipControl
                        label={tipLabel}
                        placement="bottom" />
                </div>
                {
                    Object.keys(this.props.errors).length > 0 &&
                    <div className="TotalPrice-errors">
                        {this.renderErrors()}
                    </div>
                }
                <span className="TotalPrice-sum">{<AnimationCount {...priceAnimationSettings}/>}₽</span>

                <div className="TotalPrice-submitWrap">
                    <ButtonControl
                        className="TotalPrice-submit"
                        disabled={!isTotalPrice}
                        view="sand"
                        size="m"
                        rightIcon={RIGHT_BUTTON_ARROW}
                        onClick={this.props.onSubmit}>
                        {this.props.submitText}
                    </ButtonControl>

                    {!isTotalPrice &&
                        <TipControl
                            className="TotalPrice-submitTip"
                            label="Необходимо выбрать дату перевозки"/>
                    }
                </div>
                {/*{this.props.showGoToAuctionButton ?
                    <ButtonControl
                        className="TotalPrice-helpButton TotalPrice-goToAuction"
                        view="crystal"
                        size="s"
                        rightIcon={RIGHT_BUTTON_ARROW}
                        onClick={this.props.onSubmitAuction}>
                        Разместить заявку на аукционе
                    </ButtonControl> : null}*/}
                {/*<div className="TotalPrice-orCallUs">Или позвоните нам</div>
                <div className="TotalPrice-phoneBox">
                    <IconSVG
                        className="TotalPrice-phoneTubeIcon"
                        src={require('!svg-inline!./phone_tube.svg')}/>
                    <div className="TotalPrice-phone">
                        <div className="TotalPrice-phoneLabel">Бесплатный номер для консультации</div>
                        <div className="TotalPrice-phoneNumber">8 (800) 555-19-23</div>
                    </div>
                </div>
                <div className="TotalPrice-helpInfo">
                    Мы обязательно позвоним вам, чтобы обсудить все детали вашей будущей перевозки
                </div>*/}
            </div>
        )
    }
}

export default TotalPrice



// WEBPACK FOOTER //
// ./client/components/SidebarHeaderBlock/TotalPrice.js